import { useMutation, useQueryClient } from '@tanstack/react-query'
import ConfirmationModal from 'components/ConfirmationModal'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

type DeleteProps = {
  opened: boolean
  closeModal: () => void
  paymentGateway?: PaymentGateway
}

export default function Delete({
  opened,
  closeModal,
  paymentGateway,
}: DeleteProps) {
  const { openErrorToast, openSuccessToast } = useGlobalState()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const removePaymentGateway = useMutation({
    mutationFn: async (paymentGateway: PaymentGateway) => {
      await ApiService.PaymentGateways.remove(paymentGateway.id.toString())

      openSuccessToast({
        message: `A forma de pagamento ${paymentGateway?.account_name} foi removida com sucesso!`,
      })

      navigate(ROUTES.PAYMENT_GATEWAYS.LIST)
    },
    onSuccess: (_data, paymentGateway: PaymentGateway) => {
      queryClient.setQueryData<CommercialUnit[]>(
        QUERY_KEYS.PAYMENT_GATEWAYS.LIST,
        (oldPaymentGateways) => {
          if (!oldPaymentGateways?.length) return

          return oldPaymentGateways.filter(
            (oldPaymentGateway) => oldPaymentGateway.id !== paymentGateway.id,
          )
        },
      )

      queryClient.removeQueries(
        QUERY_KEYS.COMMERCIAL_UNITS.EDIT(paymentGateway.id.toString()),
      )

      openSuccessToast({
        message: `A forma de pagamento ${paymentGateway.account_name} foi removida com sucesso!`,
      })

      navigate(ROUTES.PAYMENT_GATEWAYS.LIST)
    },
    onError: (removeError) => {
      closeModal()

      openErrorToast({
        message: (removeError as ApiError).message,
      })
    },
  })

  if (!opened) {
    return <></>
  }

  return (
    <ConfirmationModal
      opened
      title="Confirmar remoção"
      onClose={closeModal}
      onCancel={closeModal}
      onConfim={() =>
        removePaymentGateway.mutate(paymentGateway as PaymentGateway)
      }
      confirmColor="error"
    >
      Deseja realmente remover a forma de pagamento{' '}
      <strong>{`${paymentGateway?.account_name}?`}</strong>
    </ConfirmationModal>
  )
}
